import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"
import _imports_0 from '../assets/images/gotcha.png'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header-container" }
const _hoisted_3 = { class: "nav" }
const _hoisted_4 = { class: "nav-left" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "nav-right" }
const _hoisted_7 = ["disabled", "onClick"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]

import { ref, computed } from 'vue'
import { useRouter } from 'vue-router';
import User from '@/types/User';
import { supabase } from '../lib/supabase';
import { useAuthStore } from '../stores/auth';
import { useUserStore } from '@/stores/user';
import { useLoadingStore } from '../stores/loading'



export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderBar',
  props: {
    user: {}
  },
  setup(__props: any) {


const loadingStore = useLoadingStore()
const router = useRouter();
const authStore = useAuthStore();
const userStore = useUserStore();
const mobileMenuOpen = ref(false)
const activeSection = ref('')
const props = __props;

const navItems = computed(() => {
  const galleryItem = props.user
    ? { id: 'prompts', label: 'PROMPTS' }
    : { id: 'gallery', label: 'EXAMPLES' }

    if (userStore.user) {
  return [
    { id: 'works', label: 'HOW TO' },
    galleryItem,
    { id: 'prices', label: 'PRICING' },
    { id: 'contact', label: 'CONTACT' },
  ]
  } else {
    return [
          { id: 'works', label: 'HOW TO' },
    { id: 'demo', label: "WATCH DEMO"},
    galleryItem,
    { id: 'prices', label: 'PRICING' },
    { id: 'contact', label: 'CONTACT' },

    ]
  }
})

// const scrollToSection = (sectionId?: string) => {
// const element = document.querySelector(`.${sectionId}`)
// if (element) {
//     element.scrollIntoView({
//     behavior: 'smooth',
//     block: 'start',
//     })
// } else {
//     router.push("/pricing")
// }
// mobileMenuOpen.value = false
// }

const scrollToSection = (sectionId?: string) => {
  if (sectionId === 'prices') {
    router.push("/pricing")
  } else if (sectionId) {
    const element = document.querySelector(`.${sectionId}`)
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
    } 
  }
  mobileMenuOpen.value = false
}

const toggleMobileMenu = () => {
mobileMenuOpen.value = !mobileMenuOpen.value
}

const handleButtonSettings = () => {
    if (props.user?.email) {
        router.push('/settings')
    } else {
        router.push('/home')
    }
    mobileMenuOpen.value = false
};

const handleLogout = async () => {
            await supabase.auth.signOut();
            authStore.setSession(null);
            userStore.clearUser();
            router.push('/')
            mobileMenuOpen.value = false
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "logo" }, [
        _createElementVNode("h1", { class: "hero-title" }, [
          _createElementVNode("img", {
            src: _imports_0,
            class: "logo-icon"
          })
        ])
      ], -1)),
      _createElementVNode("nav", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navItems.value, (item) => {
            return (_openBlock(), _createElementBlock("button", {
              key: item.id,
              onClick: ($event: any) => (scrollToSection(item.id)),
              class: _normalizeClass(["nav-button", { active: activeSection.value === item.id }])
            }, _toDisplayString(item.label), 11, _hoisted_5))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            onClick: handleButtonSettings,
            class: "nav-button settings-button"
          }, _toDisplayString(_ctx.user ? (_ctx.user.is_subscribed ? 'Settings' : 'Subscribe') : 'Login'), 1),
          (_ctx.user)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: handleLogout,
                class: "nav-button settings-button yellow"
              }, " LOGOUT "))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("button", {
        class: "mobile-menu-btn",
        onClick: toggleMobileMenu
      }, _cache[0] || (_cache[0] = [
        _createElementVNode("span", null, null, -1),
        _createElementVNode("span", null, null, -1),
        _createElementVNode("span", null, null, -1)
      ]))
    ]),
    _createElementVNode("nav", {
      class: _normalizeClass(["mobile-nav", { open: mobileMenuOpen.value }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navItems.value, (item) => {
        return (_openBlock(), _createElementBlock("button", {
          disabled: _unref(loadingStore).isLoading,
          key: item.id,
          onClick: ($event: any) => (scrollToSection(item.id)),
          class: "mobile-nav-button"
        }, _toDisplayString(item.label), 9, _hoisted_7))
      }), 128)),
      _createElementVNode("button", {
        disabled: _unref(loadingStore).isLoading,
        onClick: handleButtonSettings,
        class: "mobile-nav-button settings-button"
      }, _toDisplayString(_ctx.user && !_ctx.user.is_subscribed ? 'Subscribe' : 'Settings'), 9, _hoisted_8),
      (_ctx.user)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            disabled: _unref(loadingStore).isLoading,
            onClick: handleLogout,
            class: "mobile-nav-button settings-button yellow"
          }, " LOGOUT ", 8, _hoisted_9))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})